export default __webpack_public_path__ + "static/media/NanumSquareEB.f318ca4d.woff2";